export function mapSelectedEntitiesToString(entities: { mrn: string }[]) {
  return entities.map((entity) => entity.mrn);
}
